import 'components/MapPage/focStepFeedbackPopover.css';
import {
  focStepRequirementKey,
  getFocStepFeedback,
} from 'components/MapPage/focStepFeedbackSession';

export const FOC_STEP_FEEDBACK_SECTION_CLASS = 'foc-step-feedback';
export const FOC_STEP_TOUR_LABEL_ATTR = 'data-foc-tour-label';
export const FOC_STEP_REQ_KEY_ATTR = 'data-foc-req-key';
export const FOC_STEP_REACTION_ATTR = 'data-foc-step-reaction';
export const FOC_STEP_TEXT_ATTR = 'data-foc-step-text';

export const FOC_STEP_REACTIONS = ['👍', '👎', '🤔', '❤️'] as const;

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}

export function focStepFeedbackSectionHtml(input: {
  tourLabel: string;
  requirementKey: string;
  reaction?: string;
  text?: string;
}): string {
  const tourAttr = escapeAttr(input.tourLabel);
  const keyAttr = escapeAttr(input.requirementKey);
  const reaction = input.reaction ?? '';
  const text = input.text ?? '';
  const buttons = FOC_STEP_REACTIONS.map((emoji) => {
    const selected = emoji === reaction ? ' foc-step-feedback__btn--selected' : '';
    return `<button type="button" class="foc-step-feedback__btn${selected}" ${FOC_STEP_REACTION_ATTR}="${escapeAttr(emoji)}" ${FOC_STEP_TOUR_LABEL_ATTR}="${tourAttr}" ${FOC_STEP_REQ_KEY_ATTR}="${keyAttr}" aria-label="React ${escapeAttr(emoji)}" aria-pressed="${emoji === reaction ? 'true' : 'false'}">${emoji}</button>`;
  }).join('');

  return [
    `<div class="${FOC_STEP_FEEDBACK_SECTION_CLASS}">`,
    '<p class="foc-step-feedback__label"><strong>Feedback</strong></p>',
    `<div class="foc-step-feedback__reactions">${buttons}</div>`,
    `<textarea class="foc-step-feedback__text" rows="3" placeholder="Feedback, questions, or suggestions…" ${FOC_STEP_TEXT_ATTR}="1" ${FOC_STEP_TOUR_LABEL_ATTR}="${tourAttr}" ${FOC_STEP_REQ_KEY_ATTR}="${keyAttr}">${escapeHtml(text)}</textarea>`,
    '</div>',
  ].join('');
}

/** Append Feedback controls for every step except the final focFeedback step. */
export function withFocStepFeedback(
  descriptionHtml: string,
  step: { id?: string; requirementId?: string; title: string },
  tourLabel: string
): string {
  if (step.id === 'focFeedback') return descriptionHtml;
  const requirementKey = focStepRequirementKey(step);
  if (!requirementKey.trim()) return descriptionHtml;
  const saved = getFocStepFeedback(tourLabel, requirementKey);
  return (
    descriptionHtml +
    focStepFeedbackSectionHtml({
      tourLabel,
      requirementKey,
      reaction: saved.reaction,
      text: saved.text,
    })
  );
}
